import React from "react";
import { DialogContentText } from "@mui/material";
import { WarningDialogContent } from "../../../../../pages/components/dialogs/confirmation-dialog/styled";
import BarekamButton, { DialogButtons } from "../../../../../pages/components/button";
import BarekamText from "../../../../../pages/components/text";
import {
    DialogActionsContainer, DialogButtonContainer,
} from "../../../../../pages/components/dialogs/standard-dialog/styled";
import { StaticDataDialogProps } from "./edit-static-data";
import Message from "../../../../../pages/components/message";
import { MessageSections } from "../../../../../pages/components/message/message";
import { TabType } from "../../../../shared/enums";
import productStoresService from "../../../../../services/product-stores.service";
import productCategoriesService from "../../../../../services/product-categories.service";
import cityService from "../../../../../services/city-service";
import regionService from "../../../../../services/region-service";
import provinceService from "../../../../../services/province-service";
import messagesService from "../../../../../services/messages.service";
import blogService from "../../../../../services/blog-service";
import onlineStoresService from "../../../../../services/online-stores-service";
import onlineStoryCategoryService from "../../../../../services/online-story-category-service";
import blogCategoryService from "../../../../../services/blog-category-service";

const DeleteStaticData = ({ onCancel, staticDataDialogProps }: EditStaticDataDialogProps) => {
    function handleDelete() {
        switch (staticDataDialogProps?.type) {
            case TabType.STORE:
                productStoresService.deleteStoreById(staticDataDialogProps?.staticData.storeId)
                    .then(() => onCancel())
                break;
            case TabType.PRODUCT_CATEGORY:
                productCategoriesService.deleteProductCategoryById(staticDataDialogProps?.staticData.productCategoryId)
                    .then(() => onCancel())
                break;
            case TabType.PROVINCE:
                provinceService.deleteProvinceById(staticDataDialogProps?.staticData.provinceId)
                    .then(() => onCancel())
                break;
            case TabType.CITY:
                cityService.deleteCityById(staticDataDialogProps?.staticData.cityId)
                    .then(() => onCancel())
                break;
            case TabType.REGION:
                regionService.deleteRegionById(staticDataDialogProps?.staticData.regionId)
                    .then(() => onCancel())
                break;
            case TabType.MESSAGES:
                messagesService.deleteMessage(staticDataDialogProps?.staticData.messageId)
                    .then(() => onCancel())
                break
            case TabType.BLOG:
                blogService.deletePostById(staticDataDialogProps?.staticData.id)
                    .then(() => onCancel())
                break;
            case TabType.BLOG_CATEGORY:
                blogCategoryService.deleteBlogCategoryById(staticDataDialogProps?.staticData.id)
                    .then(() => onCancel())
                break;
            case TabType.ONLINE_STORES:
                onlineStoresService.deleteStoreById(staticDataDialogProps?.staticData.id)
                    .then(() => onCancel())
                break;
            case TabType.ONLINE_STORE_CATEGORY:
                onlineStoryCategoryService.deleteStoreCategoryById(staticDataDialogProps?.staticData.id)
                    .then(() => onCancel())
                break;
        }
    }

    return (
        <>
            <WarningDialogContent>
                <DialogContentText>
                    <Message messageKey={'delete_static_data'} sectionId={MessageSections.MAIN} />
                </DialogContentText>
            </WarningDialogContent>

            <DialogActionsContainer>
                <DialogButtonContainer>
                    <BarekamButton type={DialogButtons.CANCEL} onClick={() => onCancel()}>
                        <BarekamText variant={'s'} fontWeight={500} align={"center"}>
                            <Message messageKey={'cancel'} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                    </BarekamButton>

                    <BarekamButton type={DialogButtons.DELETE} onClick={() => handleDelete()}>
                        <BarekamText variant={'s'} fontWeight={700} align={"center"}>
                            <Message messageKey={'delete'} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                    </BarekamButton>
                </DialogButtonContainer>
            </DialogActionsContainer>
        </>
    )
}

interface EditStaticDataDialogProps {
    onCancel: () => void,
    staticDataDialogProps?: StaticDataDialogProps
}

export default DeleteStaticData;